import * as actionTypes from '../constants/actionTypes';

const initialState = {
    provinces: null,    // [{id: "", code: "", description: ""}]
    events: null,       // [{id: "", name: "", description: ""}]
    channels: null,      // [{id: "", name: "", description: ""}]
    channelPackages: null,   // [{id: "", name: "", description: "", nameChannal: "", nameArea: ""}]
    typeImages: null,     // [{id: "", name: "", description: "", order: "", eventId: ""}]
    storeTypes: null,        // [{id: "", name: "", description: ""}]
    message: null
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SERVICE_INI:
            return state;
        case actionTypes.SERVICE_SET_PROVINCE:
            return {
                ...state,
                provinces: action.data
            }
        case actionTypes.SERVICE_SET_EVENT:
            return {
                ...state,
                events: action.data
            }
        case actionTypes.SERVICE_SET_CHANNEL:
            return {
                ...state,
                channels: action.data
            }
        case actionTypes.SERVICE_SET_CHANNEL_PACKAGE:
            return {
                ...state,
                channelPackages: action.data
            }
        case actionTypes.SERVICE_SET_TYPE_IMAGE:
            return {
                ...state,
                typeImages: action.data
            }
        case actionTypes.SERVICE_SET_STORE_TYPE:
            return {
                ...state,
                storeTypes: action.data
            }
        case actionTypes.SERVICE_SET_MESSAGE:
            return {
                ...state,
                message: action.data
            }
        default:
            return state;
    }
}

export default reducer;